import $ from 'jquery';
import 'slick-carousel';

const TabSlider = () => {

    const sliders = document.querySelectorAll('[data-tab-slider]');

    sliders.forEach(slider => {

        let this_slider = $(slider);
        let slider_ref = slider.getAttribute('data-tab-slider');
        let slider_nav = $('[data-tab-nav="' + slider_ref + '"]');

        let prev = this_slider.parent().find('.tabs__arrow--prev');
        let next = this_slider.parent().find('.tabs__arrow--next');

        this_slider.slick({
            accessibility: false,
            adaptiveHeight: true,
            arrows: true,
            asNavFor: slider_nav,
            dots: false,
            draggable: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: prev,
            nextArrow: next
        });
      
        slider_nav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: this_slider,
            dots: false,
            focusOnSelect: true
        });
    });
}


export default TabSlider;